<h1 matDialogTitle>Details for Non Stock Code {{data.stockCode}}</h1>

<mat-dialog-content>
  <ng-container *ngIf="loading; else loaded">
    <div style="padding: 16px;border-radius: 5px;">
      Loading details, please wait ...
    </div>
  </ng-container>
  <ng-template #loaded>
    <ng-container *ngIf="error; else detailsSection">
      <div style="background-color: tomato;padding: 16px;border-radius: 5px;">
        {{error}}
      </div>
    </ng-container>
  </ng-template>
  <ng-template #detailsSection>
    <div>
      <table style="width: 100%;">
        <tr>
          <th class="th-label">Invoice Number</th>
          <td class="td-value" style="text-align: right; padding-right: 16px;">{{details.ledaineInvoiceNumber}}</td>
          <th class="th-label">Date</th>
          <td class="td-value" style="text-align: right;">{{details.orderDate | date:'yyyy-MM-dd'}}</td>
        </tr>
        <tr>
          <th class="th-label">Order Number</th>
          <td class="td-value" style="text-align: right; padding-right: 16px;">{{details.ledaineOrderNumber}}</td>
          <th class="th-label">Total RSP</th>
          <td class="td-value" style="text-align: right;">{{details.totalRsp | number:'1.2-2'}}</td>
        </tr>
        <tr>
          <th class="th-label">PO Number</th>
          <td class="td-value" style="text-align: right; padding-right: 16px;">{{details.ledaineCustomerPoNumber}}</td>
          <th class="th-label">Total Qty</th>
          <td class="td-value" style="text-align: right;">{{details.totalQty | number:'1.2-2'}}</td>
        </tr>

      </table>
    </div>
    <div style="margin-top: 16px;">
      <kendo-grid style="max-height: 250px" [kendoGridBinding]="details.lines" [scrollable]="true"
                [resizable]="true" [reorderable]="true" [sortable]="true" [loading]="loading">

            <kendo-grid-column [width]="70" field="lineSequence" title="Line #"></kendo-grid-column>
            <kendo-grid-column [width]="100" field="productCode" title="Product Code"></kendo-grid-column>
            <kendo-grid-column [width]="200" field="productDesc" title="Product Desc."></kendo-grid-column>
            <kendo-grid-column [width]="70" class="td-number" field="orderQty" title="Line Qty">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="td-number">{{dataItem.orderQty | number:'1.0-0'}}</div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [width]="70" class="td-number" field="lineRsp" title="Line RSP">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="td-number">{{dataItem.lineRsp | number:'1.0-2'}}</div>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button matDialogClose>Close</button>
</mat-dialog-actions>
